export default __webpack_public_path__ + "static/media/wallpaper.d346c860.jpg";